import * as React from 'react';

import styles from './styles.module.scss';

interface Props {
	name: string;
}

const SelectToLoad: React.FC<Props> = (props) => {
	const { name } = props;

	return (
		<div className={styles.selectToLoad}>
			<span className={`icon-warning ${styles.iconWarning}`} />
			Select <b>{name}</b> to display data
		</div>
	);
};

export default React.memo(SelectToLoad);
